/**
 * Copy to Clipboard
 * Binds any #clipboard-copy or .js-clipboard-copy button. The text copied is,
 * in order of preference:
 *   1. the button's data-clipboard-text attribute
 *   2. the text of the element matched by data-clipboard-target (a selector)
 *   3. the number text inside the surrounding .hero-badge
 * On success the button briefly shows confirmation text.
 */
export function clipboardCopy() {

    const SELECTOR = '#clipboard-copy, .js-clipboard-copy';
    const DONE_TEXT = 'Copied!';
    const DONE_MS = 1500;

    function resolveText($btn) {
        const explicit = $btn.attr('data-clipboard-text');
        if (explicit) {
            return explicit.trim();
        }

        const targetSel = $btn.attr('data-clipboard-target');
        if (targetSel && $(targetSel).length) {
            return $(targetSel).first().text().trim();
        }

        //Fallback: the bare number/text in the hero badge, minus the label and button.
        const $badge = $btn.closest('.hero-badge, .routing-badge');
        if ($badge.length) {
            return $badge.clone().children().remove().end().text().trim();
        }

        return '';
    }

    function writeToClipboard(text) {
        //Modern async Clipboard API (needs a secure context: https or localhost).
        if (navigator.clipboard && window.isSecureContext) {
            return navigator.clipboard.writeText(text);
        }

        //Fallback for older browsers / non-secure contexts.
        return new Promise(function(resolve, reject) {
            const $temp = $('<textarea>')
                .val(text)
                .css({ position: 'fixed', top: '-9999px', opacity: 0 })
                .appendTo('body');
            $temp[0].select();
            try {
                document.execCommand('copy') ? resolve() : reject();
            } catch (err) {
                reject(err);
            } finally {
                $temp.remove();
            }
        });
    }

    $(document).on('click', SELECTOR, function(e) {
        e.preventDefault();

        const $btn = $(this);
        const text = resolveText($btn);
        if (!text) {
            return;
        }

        writeToClipboard(text).then(function() {
            //Guard against double-clicks stacking the timeout / label.
            if ($btn.data('copyResetTimer')) {
                return;
            }
            const original = $btn.html();
            $btn.html(DONE_TEXT).addClass('is-copied');
            const timer = setTimeout(function() {
                $btn.html(original).removeClass('is-copied').removeData('copyResetTimer');
            }, DONE_MS);
            $btn.data('copyResetTimer', timer);
        }).catch(function() {
            //Silently ignore — nothing better to do if the browser blocks it.
        });
    });
}
